export default {
  folders: state => state.folders,
  uiFlags: state => state.uiFlags,
  folderById: state => id => state.folders.find(f => f.id === id),
};
